/** @jsx jsx */
import React from "react"
import { jsx, Styled } from 'theme-ui'

const PageTitle = (props) => (
  <Styled.h1>{props.title}</Styled.h1>
)

export default PageTitle